

import Vue from 'vue'
import Component from "vue-class-component";

import {Prop, Watch} from "vue-property-decorator";
import {IServiceProvider, ISPCategory} from "@/model/Service/serviceProviderInterfaces";
import {IErrors} from "@/model/IErrors";
import LinkChip from "@/components/shared/chips/LinkChip.vue";
import {Location} from "vue-router";
import {IOnOffHandlers} from "bonomo/dist";

@Component({
    components: {LinkChip}
  })
  export default class SPCategories extends Vue {

    @Prop()
    protected provider!: IServiceProvider;
    @Prop()
    protected errors!: IErrors;
    @Prop()
    protected viewing!: boolean;
    @Prop()
    protected canEdit!: boolean;
    @Prop()
    protected editing!: boolean;
    @Prop()
    protected disabled!: boolean;
    // @Prop()
    // protected submitting!: boolean;
    protected submitting: boolean = false;
    private subscribes: IOnOffHandlers = {};

    protected connectModels: {
      [key: string]: boolean
    } = {
      10: false,
      20: false,
      30: false,
      40: false,
      50: false,
      60: false,
      70: false,
      80: false,
      110: false,
      120: false,
      130: false,
      140: false,
      150: false,
      160: false,
      170: false,
      210: false,
      220: false,
      230: false,
      240: false,
      250: false,
      260: false,
      270: false,
      280: false,
      290: false,
      300: false,
    }

    @Watch('provider.categories')
    protected onCategoriesChanged() {
      this.updateConnectModels();
    }

    private get spHasCategories(): boolean {
      return !!this.provider.categories.length;
    }

    protected get categories(): any {
      // return this.$t('services.provider.categories.values');
      return this.connectModels;
    }

    protected get visibleCategories(): any {
      return Object.keys(this.connectModels)
        .filter(id => this.showSwitch(+id))
        .reduce((acc, id) => { acc[id] = this.connectModels[id]; return acc; }, {} as any);
    }

    created() {
      this.updateConnectModels();
      this.subscribes = this.$ons({
        // 'login.OK': this.loadData,
        'backend.call.OK.serviceProviderLoaded': this.onOK,
        'backend.call.KO.serviceProviderLoaded': this.onKO,
      });
    }

    protected chipLink(categoryId: number): Location {
      return {
        name: 'serviceProviderCategories',
        params: { categoryId: ''+categoryId },
      };
    }

    protected onConnect(categoryId: number) {
      this.submitting = true;
      this.$store.dispatch('serviceProviderModule/connectCategory', {
        serviceProviderId: this.provider.id,
        categoryId,
        connect: !this.connectModels[categoryId],
      });
    }

    showSwitch(categoryId: number): boolean {
      return (categoryId > 200) || this.connectModels[categoryId];
    }

    protected whereLink(categoryId: number): Location {
      return {
        name: 'serviceProviderCategories',
        params: { categoryId: '' + categoryId },
      };
    }

    private updateConnectModels() {
      Object.keys(this.connectModels).forEach(
          (eachId: string) => {
            this.connectModels[eachId] = !!this.provider.categories
                .find((each: ISPCategory): boolean => ''+each.id == eachId);
          }
      );
    }

    private onOK() {
      if (this.submitting) {
        this.$uiBus.emit('success', this.$t('common.saved'));
        this.submitting = false;
      }
      this.updateConnectModels();
    }

    private onKO() {
      this.submitting = false;
      this.updateConnectModels();
    }

  }

